import { render, staticRenderFns } from "./oldest.vue?vue&type=template&id=ca2e65be"
import script from "./oldest.vue?vue&type=script&lang=js"
export * from "./oldest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports